import {Component, OnInit, Input, OnDestroy, Renderer2} from '@angular/core';
import {LotteriesService} from '../lotteries.service';
import * as globals from '../settings';
import {SubscriptionsService} from '../_services/subscriptions.service';
import {Subscription} from 'rxjs';
import {PlatformLocation} from '@angular/common';
import {UserService} from '../_services/user.service';
import {Router} from '@angular/router';
import {GameLauncherService} from '../_services/game-launcher.service';
import {GetPaymentMethodsService} from '../shared/paymentMethod/get-payment-methods.service';
import {ReloadGameService} from '../_services/reload-game.service';
import {auditTime} from 'rxjs/operators';

@Component({
    selector: 'app-insta-run',
    templateUrl: './insta-run.component.html',
    styleUrls: ['./insta-run.component.scss']
})
export class InstaRunComponent implements OnInit, OnDestroy {
    fscr: boolean;
    runAnim: boolean;
    @Input() gameId;
    @Input() mode;
    @Input() error;
    @Input() screen;
    @Input() url;
    language: string;
    isMobile: any;
    gameURL: string;
    frameWidth: number;
    frameHeight: number;
    showIframe: boolean;
    ifGameError: boolean;
    isLoadingButton: boolean;
    error000: boolean;
    error102: boolean;
    error069: boolean;
    error1042: boolean;
    error10422: boolean;
    gameBackground: string;
    runGameSubscription: Subscription;
    loggedStatus: Subscription;
    closeGameSub: Subscription;
    reloadGameNow: Subscription;
    allowFullScreen: boolean;
    classyOpenedGame: any;
    brand = globals.brand;
    reload: boolean;
    constructor(public lotteryService: LotteriesService,
                private subscriptionsService: SubscriptionsService,
                public gameLauncherService: GameLauncherService,
                public router: Router,
                public userService: UserService,
                private renderer: Renderer2,
                public reloadGame: ReloadGameService,
                location: PlatformLocation,
                public getPaymentMethodService: GetPaymentMethodsService,
                private gameLauncher: GameLauncherService) {
        this.fscr = false;
        this.runAnim = false;
        this.runGameSubscription = this.subscriptionsService.getRunGameFromAddFunds().subscribe(gameId => {
            this.runGame(gameId);
        });

        this.reloadGameNow = this.subscriptionsService.getReloadGame().pipe(auditTime(500)).subscribe( gameId => {
            this.closeGame(this.gameId, false);
        });

        this.closeGameSub = this.subscriptionsService.getCloseGameStatus().subscribe(data => {
          this.closeGame(this.gameId, true);
        });

        location.onPopState(() => {
            setTimeout(() => {
                this.subscriptionsService.emitStartInstant('off');
            }, 300);
        });

        this.subscriptionsService.getGameBackground().subscribe(url => {
            this.gameBackground = url;
            localStorage.setItem('gameBackground', this.gameBackground);
        });

        this.loggedStatus = this.subscriptionsService.getLoggedInStatus().subscribe(data => {
            if (!data) {
                this.runAnim = false;
                this.gameBackground = '';
                this.subscriptionsService.emitGameBackground(this.gameBackground);
                this.renderer.removeClass(document.body, 'modal-open-game');
                this.closeGame(this.classyOpenedGame, false);
                this.subscriptionsService.emitStartInstant('off');
            }
        });
    }

    ngOnInit() {
        if (localStorage.getItem('gameBackground')) {
            this.gameBackground = localStorage.getItem('gameBackground');
            localStorage.removeItem('gameBackground');
        }
        setTimeout(() => {
            this.runAnim = true;
        }, 300);
        this.language = localStorage.getItem('pageLanguage');
        if (this.gameId) {
            this.getGameStartStatus(this.gameLauncherService.error, this.gameLauncherService.url,
                this.gameLauncherService.screen, this.gameId);
        } else {
            this.getGameStartStatus(this.gameLauncherService.error, this.gameLauncherService.url,
                this.gameLauncherService.screen, this.gameLauncherService.gameId);
        }
    }

    ngOnDestroy() {
        if (this.runGameSubscription) {
            this.runGameSubscription.unsubscribe();
        }
        if (this.loggedStatus) {
            this.loggedStatus.unsubscribe();
        }
        if (this.closeGameSub) {
          this.closeGameSub.unsubscribe();
        }

        if (this.reloadGameNow) {
          this.reloadGameNow.unsubscribe();
        }
    }

    fullScreen() {
        this.fscr = !this.fscr;
    }

    getGameStartStatus(error, url, screen, gameId) {
        this.classyOpenedGame = gameId;
        if (!error || !url) {
            this.runGame(gameId);
            return false;
        }
        let mobile = false;
        if (window && (window.navigator.userAgent.includes('iPad') || window.navigator.userAgent.includes('iPhone'))) {
            mobile = true;
        } else {
            mobile = this.lotteryService.isMobile;
        }
        if (error === -1) {
            this.allowFullScreen = screen;
            this.renderer.addClass(document.body, 'modal-open-game');
            const origin = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
            if (mobile) {
                this.gameURL = url;
                let urlAddon = '';
                if (url.includes('playngonetwork')) {
                  urlAddon = '&origin=' + origin + '&lobby=' + origin + '#game-closed';
                } else {
                  urlAddon = '&lobbyUrl=' + origin + '#game-closed';
                }
                this.gameURL += urlAddon;
                this.frameWidth = window.innerWidth;
                this.frameHeight = 860;
                window.open(this.gameURL, '_self');
            } else if (window.innerWidth < 1050) {
                let urlAddon = '';
                if (url.includes('playngonetwork')) {
                  urlAddon = '&origin=' + origin + '&lobby=' + origin + '#game-closed';
                } else {
                  urlAddon = '&lobbyUrl=' + origin + '#game-closed';
                }
              this.gameURL = url;
                this.gameURL += urlAddon;
                this.frameWidth = window.innerWidth - (window.innerWidth / 10);
                if (gameId === 'fly_piggy_fly') {
                    this.frameHeight = 560;
                } else {
                    this.frameHeight = 540;
                }
                if (url.includes('isoftbet')) {
                    this.frameHeight = 553;
                }
                setTimeout(() => {
                    this.showIframe = true;
                }, 100);
            } else {
                let urlAddon = '';
                if (url.includes('playngonetwork')) {
                  urlAddon = '&origin=' + origin + '&lobby=' + origin + '#game-closed';
                } else {
                  urlAddon = '&lobbyUrl=' + origin + '#game-closed';
                }
                this.gameURL = url;
                this.gameURL += urlAddon;
                if (this.mode === 'casino') {
                    this.frameWidth = 980;
                } else {
                    this.frameWidth = 960;
                }
                if (gameId === 'fly_piggy_fly') {
                    this.frameHeight = 560;
                } else {
                    this.frameHeight = 540;
                }
                if (url.includes('isoftbet')) {
                    this.frameHeight = 553;
                }
                setTimeout(() => {
                    this.showIframe = true;
                }, 100);
            }
        } else {
            this.ifGameError = true;
            if (error === '102') {
                this.error000 = false;
                this.error102 = true;
                this.subscriptionsService.emitUserNeedIncreseBalance(gameId);
            } else if (error === '069') {
                this.showIframe = false;
                this.error069 = true;
                this.error000 = true;
                this.error102 = false;
                localStorage.setItem('dashboardStatus', 'verification');
                this.router.navigate(['/' + this.language, 'dashboard']);
            } else if (error === '10422') {
                this.showIframe = false;
                this.error000 = false;
                this.error10422 = true;
            } else if (error) {
                this.showIframe = false;
                this.error000 = false;
                this.error1042 = true;
            } else if (error !== '102') {
                this.error000 = true;
                this.error102 = false;
            }
        }

        this.reloadGame.gameListener(this.gameURL, gameId);
    }


    runGame(gameId) {
      console.log('dupka');
        this.classyOpenedGame = gameId;
        this.userService.checkStatus(this.userService.userData.Status).then((val) => {
            let mobile = false;
            if (window && (window.navigator.userAgent.includes('iPad') || window.navigator.userAgent.includes('iPhone'))) {
                mobile = true;
            } else {
                mobile = this.lotteryService.isMobile;
            }
            if (val === 'noRedirect') {
                this.error069 = false;
                this.error000 = false;
                this.error102 = false;
                const data = 'sessionId=' + this.userService.userData.sessionId + '&gameId=' + gameId + '&language=' + this.language + '&isMobile=' + mobile;
                this.lotteryService.postData(globals.appDomain + '/instantGames/startGameSession/startGameSession_instaRun.json', data).subscribe(
                    result => {
                        window.location.hash = '';
                        if (!result.message.ErrorID) {
                          const origin = window.location.protocol + window.location.host + window.location.pathname;
                            this.allowFullScreen = result.message.Fullscreen;
                            this.renderer.addClass(document.body, 'modal-open-game');
                            if (mobile) {
                                this.gameURL = result.message.EmbedUrl;
                                let urlAddon = '';
                                if (result.message.EmbedUrl.includes('playngonetwork')) {
                                   urlAddon = '&origin=' + origin + '&lobby=' + origin + '#game-closed';
                                } else {
                                  urlAddon = '&lobbyUrl=' + origin + '#game-closed';
                                }
                                this.gameURL += urlAddon;
                                this.frameWidth = window.innerWidth;
                                this.frameHeight = 860;
                                window.open(this.gameURL, '_self');
                            } else if (window.innerWidth < 1050) {
                                let urlAddon = '';
                                if (result.message.EmbedUrl.includes('playngonetwork')) {
                                  urlAddon = '&origin=' + origin + '&lobby=' + origin + '#game-closed';
                                } else {
                                  urlAddon = '&lobbyUrl=' + origin + '#game-closed';
                                }
                                this.gameURL = result.message.EmbedUrl;
                                this.gameURL += urlAddon;
                                this.frameWidth = window.innerWidth - (window.innerWidth / 10);
                                if (gameId === 'fly_piggy_fly') {
                                    this.frameHeight = 560;
                                } else {
                                    this.frameHeight = 540;
                                }
                                if (result.message.EmbedUrl.includes('isoftbet')) {
                                    this.frameHeight = 553;
                                }
                                setTimeout(() => {
                                    this.showIframe = true;
                                }, 100);
                            } else {
                                let urlAddon = '';
                                if (result.message.EmbedUrl.includes('playngonetwork')) {
                                  urlAddon = '&origin=' + origin + '&lobby=' + origin + '#game-closed';
                                } else {
                                  urlAddon = '&lobbyUrl=' + origin + '#game-closed';
                                }
                                this.gameURL = result.message.EmbedUrl;
                                this.gameURL += urlAddon;
                                if (this.mode === 'casino') {
                                    this.frameWidth = 980;
                                } else {
                                    this.frameWidth = 960;
                                }
                                if (gameId === 'fly_piggy_fly') {
                                    this.frameHeight = 560;
                                } else {
                                    this.frameHeight = 540;
                                }
                                if (result.message.EmbedUrl.includes('isoftbet')) {
                                    this.frameHeight = 553;
                                }
                                setTimeout(() => {
                                    this.showIframe = true;
                                }, 100);
                            }
                        } else {
                            this.ifGameError = true;
                            if (result.message.ErrorID === '102') {
                                this.error000 = false;
                                this.error102 = true;
                                this.subscriptionsService.emitUserNeedIncreseBalance(gameId);
                            } else if (result.message.ErrorID === '069') {
                                this.showIframe = false;
                                this.error069 = true;
                                this.error000 = true;
                                this.error102 = false;
                                localStorage.setItem('dashboardStatus', 'verification');
                                this.router.navigate(['/' + this.language, 'dashboard']);
                            } else if (result.message.ErrorID === '10422') {
                                this.showIframe = false;
                                this.error000 = false;
                                this.error10422 = true;
                            } else if (result.message.ErrorID === '1042') {
                                this.showIframe = false;
                                this.error000 = false;
                                this.error1042 = true;
                            } else if (result.message.ErrorID !== '102') {
                                this.error000 = true;
                                this.error102 = false;
                            }
                        }
                    }
                );
            } else if (val === 'redirect') {
                this.subscriptionsService.emitStartInstant('off');
                this.subscriptionsService.emitFakeCart(false);
            }
        });
    }

    closeGame(openedGame, justClose) {
        this.classyOpenedGame = openedGame;
        const userDataString = localStorage.getItem('playerDetails');
        const thisUser = JSON.parse(userDataString);
        this.subscriptionsService.upodateHandleScratchCarousel({owlRun: false});
        const data = 'sessionId=' + this.userService.userData.sessionId + '&gameId=' + openedGame;
        this.lotteryService.postData(globals.appDomain + '/instantGames/endGameSession/endGameSession_instarun.json', data).subscribe(
            result => {
                this.subscriptionsService.updateTriggeredEndGameSessionIG(false);
                thisUser.TotalBalance = result.message.TotalBalance;
                localStorage.setItem('playerDetails', JSON.stringify(thisUser));
                this.runAnim = false;
                if (justClose) {
                  this.subscriptionsService.emitUserNeedIncreseBalance(-1);
                  this.subscriptionsService.checkIfGameClose(true);
                }
                this.subscriptionsService.updateBalance(result.message.TotalBalance);
                this.subscriptionsService.emitRefreshEntries(true);
                setTimeout(() => {
                  this.subscriptionsService.emitStartInstant('off');
                  this.gameBackground = '';
                  this.renderer.removeClass(document.body, 'modal-open-game');
                }, 300);

                this.updateBalance(result.message.Balance,
                  result.message.BonusBalance,
                  result.message.TotalBalance,
                  result.message.WinningBalance);

                this.userService.getUser();
                window.location.hash = 'game-closed';
            }
        );
        if (this.mode === 'casino') {
            this.subscriptionsService.checkIfGameClose(true);
        }
        if (localStorage.getItem('gameBackground')) {
            localStorage.removeItem('gameBackground');
        }
        this.gameBackground = '';
        this.subscriptionsService.emitGameBackground(this.gameBackground);
    }

    updateBalance(balance, bonusBalance, totalBalance, winningBalance) {
        const c = JSON.parse(localStorage.getItem('playerDetails'));
        c.Balance = balance;
        c.BonusBalance = bonusBalance;
        c.TotalBalance = totalBalance;
        c.WinningBalance = winningBalance;
        c.RealBalance = +balance + +winningBalance;
        localStorage.setItem('playerDetails', JSON.stringify(c));
    }

    runAddPM() {
        this.subscriptionsService.emitRegister(true);
        this.subscriptionsService.onlyPmStep(true);
    }

    stopGame(openedGame) {
        this.classyOpenedGame = openedGame;
        localStorage.setItem('gameIdFromAddDepositFromGame', openedGame);
        if (localStorage.getItem('gameBackground')) {
            const background = localStorage.getItem('gameBackground');
            setTimeout(() => {
                localStorage.setItem('gameBackground', background);
            }, 1000);
        }
        this.closeGame(openedGame, false);
    }

    addFundsOrPM(openedGame) {
        this.stopGame(openedGame);
        if (this.getPaymentMethodService.pmsCounter > 0 || this.brand === 'winaija') {
            this.addFunds(openedGame);
        } else {
            if (this.gameId) {
                this.subscriptionsService.emitCurrentGameId(this.gameId);
            } else {
                this.subscriptionsService.emitCurrentGameId('-1');
            }
            this.runAddPM();
        }
    }

    addFunds(openedGame) {
        this.subscriptionsService.holdAddPmOpen(true);
        setTimeout(() => {
            this.gameLauncher.gameId = openedGame;
            this.subscriptionsService.emitUserNeedMoreMoney(openedGame);
        }, 750);
        setTimeout(() => {
            this.subscriptionsService.holdAddPmOpen(false);
        }, 5001);
    }

}
